import React from 'react';

const ImagesSection = ({ images }) => {
  if (!images || images.length === 0) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {images.map((image, index) => (
        <div key={index} className="relative">
          <div className="absolute top-0 left-0 right-0 bg-black bg-opacity-50 text-white p-1 rounded-t-lg text-center text-xs">
            {image.image_type}
          </div>
          <img
            src={image.image_url}
            alt={image.image_type === 'coin_obverse' ? 'Obverse' : 'Reverse'}
            className="w-full h-auto rounded-lg shadow-md max-h-[300px] object-contain"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/placeholder.jpg';
            }}
            data-image-id={`form-${index}`}
          />
        </div>
      ))}
    </div>
  );
};

export default ImagesSection;
